import { User } from '../interfaces';

export const getUserName = (user: User) => {
  if (!user) {
    return null;
  }

  const { cognito_id, name, surname, email } = user;

  let fullname = `${name ?? ''} ${surname ?? ''}`;
  if (fullname === ' ') {
    fullname = email || cognito_id;
  }

  return fullname;
};
